import { render, staticRenderFns } from "./ParkingRequests.vue?vue&type=template&id=ca1c9324&scoped=true"
import script from "./ParkingRequests.vue?vue&type=script&lang=js"
export * from "./ParkingRequests.vue?vue&type=script&lang=js"
import style0 from "./ParkingRequests.vue?vue&type=style&index=0&id=ca1c9324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1c9324",
  null
  
)

export default component.exports